import React from 'react'
import { UserTag } from 'iconsax-react'

import CommonButton from '../CommonButton'
import ChipAutocomplete from '@SonarCX/components/atoms/ChipAutocomplete'

import useTaskMultiEdit from '../hooks/useTaskMultiEdit'
import useStyles from '../commonStyles'

const SetLead: React.FC = () => {
  const { selected, patchTasks } = useTaskMultiEdit()

  const [value, setValue] = React.useState(null)

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setValue(null)
  }, [])

  const handleAccept = React.useCallback(async () => {
    const updates: TaskPatch[] = selected.map(id => ({
      id,
      primary_assignee_id: value
    }))
    await patchTasks({ updates, message: 'Lead updated' })
    handleClose()
  }, [selected, value, patchTasks, handleClose])

  return (
    <CommonButton
      title='Set lead'
      Icon={UserTag}
      onAccept={handleAccept}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <div className={classes.title}>Lead</div>

        <ChipAutocomplete
          placeholder='Type and Search...'
          value={value}
          onChange={id => {
            if (!id) {
              setValue(null)
              return
            }

            setValue(id)
          }}
          internal
          single
          includeMe
        />
      </div>
    </CommonButton>
  )
}

export default SetLead
